export const VERSION_APP = '1.0.1';
export const HOME_DIR = '/';
export const ENV = {
    PROD: {
        API_BASE_URL1: 'https://script.google.com/macros/s/AKfycbx8zjJwF-MtUwHBkwVQ_HKhTZP4nuWjH0qulD6DIIbwmvkBZ2_SH2d8qvupkch5K60r/exec',
        API_BASE_URL2: 'https://script.google.com/macros/s/AKfycbxD3DMsfKbLIcNv_gkkMDP2Cou1fiWZ6DCMo_ubWk4BgEv8dMkEbFP1JO60Vz5vRAvZ/exec',
        API_BASE_URL3: 'https://script.google.com/macros/s/AKfycbxzPAR7wD1BjafrIgzQuUkCM0Z8s9EyNTbLTAiECP4YjktE8LHktcPXxNcmBa85Vpaz/exec',
        API_BASE_URL4: 'https://script.google.com/macros/s/AKfycbzdgT8PXyz8WgmRdBpAq-8REm0Y6Qs1HARFj-JfWPa-yHOGG_IjM4t9muCR-_TEJ2PLeg/exec',
        API_BASE_URL5: 'https://script.google.com/macros/s/AKfycbz6iFwuxZOKMSk6H3RNOuntmP3KN8w5Ag0Di7-hwALbw_ZX8oHYk3KORQxcoHLa20a4/exec',
        API_BASE_URL6: 'https://script.google.com/macros/s/AKfycbyhNHbyZWV909ecO8bQB6n_Md8TzfLAPjzntyRxTQ4M3wg0n-H2z7hauGtG6Hk1ypgZpg/exec',
        API_BASE_URL7: 'https://script.google.com/macros/s/AKfycbwkHuhMIohZZnw8wY63SucrzXqii0OhnJqbUGOFFWK2wXIDSNhDRxKEXkWjWgaX4_m1/exec',
        API_BASE_URL8: 'https://script.google.com/macros/s/AKfycbxhXKwfxh5om1N9cEqYFev2aaTcPD0jDngOOne_PaaxQ1h-5I0Bqn_qf3XAZKsTvLQy/exec',
        API_BASE_URL9: 'https://script.google.com/macros/s/AKfycbzMoGNVVQNORv7jxGLGJ6X5KLShYxnBlNe44iNYMWn1LbOEvMV8XbLkOqsOpCMSPuID/exec',
        API_BASE_URL10: 'https://script.google.com/macros/s/AKfycbz1xGojK6xqpdWQAMaiX8cHbHU8JwD4kNxPcHyV8r-lBe2RSnEj3IAk8M9mykrNhFEwhg/exec',
        API_BASE_URL11: 'https://script.google.com/macros/s/AKfycbzSPYS7xMrd6uRgwQv-3M746Cy1oi7s5hmH93pBannu7U3W7hCOl2nbkIfg-aFSLJ5Wvw/exec',
        API_BASE_URL12: 'https://script.google.com/macros/s/AKfycbyawrFa-XJXvQnXBdd9T_Q3trJQVsjpPx8eAfOufG0FLvUp4r27I_bFXM_42JstKr4m/exec',
        API_BASE_URL13: 'https://script.google.com/macros/s/AKfycbzc4NIdrioqc9eOqGnpy-iIHLqPxFvs7V72_9DwGMRmWZ8AvOkCgK7IObxCtcMRY7RBgw/exec',
        API_BASE_URL14: 'https://script.google.com/macros/s/AKfycbyCTW_ucKubw9Yd0-8gOZOGLltPWAiepUKheNCr0OoHqggjYsntbeKH7wlOeJpg1s46/exec',
        API_BASE_URL15: 'https://script.google.com/macros/s/AKfycbwy3WuJhXRfm_P_3cH3AjI-qsooHpsc6KFNtO9Enacge7veXBnz_FJwd5LNUR1KBZrA/exec',
        API_BASE_URL16: 'https://script.google.com/macros/s/AKfycbwkq-o-ozLZFFuIq1xd9bDw4wZxQWYRRYTF3sM_K-s2Wl21q_YmbJHIxW5CXZMUZJYk/exec',
        LIFF_ID1: '2005555066-ONXgjeLZ',
        LIFF_ID2: '2005555066-k32MOGW6',
        LIFF_ID3: '2005555066-RWv8QGL0',
        LIFF_ID4: '2005555066-dERPb5gQ',
        LIFF_ID5: '2005555066-ljxoA6rd',
        LIFF_ID6: '2005555066-qxoGRYb9',
        LIFF_ID7: '2005555066-KkwoV41E',
        LIFF_ID8: '2005555066-mDrZ9vdz',
        LIFF_ID9: '2005555066-eN3oJnqb',
        LIFF_ID10: '2005555066-Z8D1vXGz',
        LIFF_ID11: '2005555066-l0LRrzxD',
        LIFF_ID12: '2005555066-5nzjr2n7',
        LIFF_ID13: '2005555066-zDERW3gY',
        LIFF_ID14: '2005555066-JpEo4dpy',
        LIFF_ID15: '2005555066-MqX14qRN',
        LIFF_ID16: '2005555066-XJnDaWgj',
        FLEX_IMAGE1: 'https://i.postimg.cc/pr5WY4LC/flex1.png',
        FLEX_IMAGE2: 'https://i.postimg.cc/MGzG299Z/flex2.png',
        FLEX_IMAGE3: 'https://i.postimg.cc/wjXBGCcb/flex3.png',
        FLEX_IMAGE4: 'https://i.postimg.cc/GpzmcvfF/flex4.png',
        FLEX_IMAGE5: 'https://i.postimg.cc/50h0GbGT/flex5.png',
        FLEX_IMAGE6: 'https://i.postimg.cc/63m6ZttT/flex6.png',
        FLEX_IMAGE7: 'https://i.postimg.cc/1zRNcRhK/flex7.png',
        FLEX_IMAGE8: 'https://i.postimg.cc/WtR298Dv/flex8.png',
        FLEX_IMAGE9: 'https://i.postimg.cc/J4cn6wQY/flex9.png',
        FLEX_IMAGE10: 'https://i.postimg.cc/TYX1J2nW/flex10.png',
        FLEX_IMAGE11: 'https://i.postimg.cc/bwmvPQWQ/flex11.png',
        FLEX_IMAGE12: 'https://i.postimg.cc/br0zBb1S/flex12.png',
        FLEX_IMAGE13: 'https://i.postimg.cc/N0WBGb4r/flex13.png',
        FLEX_IMAGE14: 'https://i.postimg.cc/XYP0xxtD/flex14.png',
        FLEX_IMAGE15: 'https://i.postimg.cc/1tGhmSXL/flex15.png',
        FLEX_IMAGE16: 'https://i.postimg.cc/MH9XMxp4/flex16.jpg',
    }
}

export const CURRENT_ENV = ENV.PROD;
